const path = window.location.pathname.split('/');
export const API_PATH = `/${path[1]}/${path[2]}/${path[3]}/api.php`;
